import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useEmployee } from '@/contexts/EmployeeContext'
import { useToast } from '@/hooks/use-toast'
import { User } from 'lucide-react'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

const EmployeeLogin = () => {
  const navigate = useNavigate()
  const { employees } = useEmployee()
  const { toast } = useToast()

  const [email, setEmail] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    if (!email.trim()) {
      toast({
        title: 'E-posta Gerekli',
        description: 'Lütfen e-posta adresinizi girin.',
        variant: 'destructive',
      })
      return
    }

    const employee = employees.find((emp) => emp.email.toLowerCase() === email.toLowerCase())

    if (employee) {
      // Store employee info in session storage
      sessionStorage.setItem('currentEmployeeId', employee.id)
      sessionStorage.setItem('currentEmployeeName', employee.name)

      toast({
        title: 'Giriş Başarılı',
        description: `Hoş geldiniz, ${employee.name}!`,
      })

      navigate('/employee/dashboard')
    } else {
      toast({
        title: 'Giriş Başarısız',
        description: 'Bu e-posta adresiyle kayıtlı çalışan bulunamadı.',
        variant: 'destructive',
      })
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 flex items-center justify-center p-6">
        <Card className="w-full max-w-md shadow-lg">
          <CardHeader className="space-y-1">
            <div className="flex justify-center mb-4">
              <div className="bg-gray-100 rounded-full p-3">
                <User className="h-8 w-8 text-gray-600" />
              </div>
            </div>
            <CardTitle className="text-2xl text-center">Çalışan Girişi</CardTitle>
            <CardDescription className="text-center">
              Atanan sınavlarınızı görmek için giriş yapın
            </CardDescription>
          </CardHeader>
          <form onSubmit={handleSubmit}>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-posta</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="ornek@sirket.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="text-center text-sm text-gray-500">
                <p>Sisteme kayıtlı e-posta adresinizi girin.</p>
                <p>Şifre gerekmemektedir.</p>
              </div>
            </CardContent>
            <CardFooter>
              <Button type="submit" className="w-full">
                Giriş Yap
              </Button>
            </CardFooter>
          </form>
          <div className="px-6 pb-6 text-center">
            <Button variant="link" onClick={() => navigate('/')}>
              Ana Sayfaya Dön
            </Button>
          </div>
        </Card>
      </main>

      <Footer />
    </div>
  )
}

export default EmployeeLogin
